<script setup lang="ts">
import { CameraIcon } from '#shared/components/icons';
import type { UiColor } from '#shared/types/ui';

const props = withDefaults(
  defineProps<{
    src?: string | null;
    backgroundColor?: UiColor;
  }>(),
  { src: undefined, backgroundColor: 'white-secondary' }
);
</script>

<template>
  <div
    class="placeholderable-img"
    :class="[`placeholderable-img_background_${props.backgroundColor}`]"
  >
    <CameraIcon />
    <img v-if="props.src" :src="props.src" />
  </div>
</template>

<style scoped lang="scss">
.placeholderable-img {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;

  svg {
    width: 20%;
    height: 20%;
  }

  img {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
  }

  @each $color-name, $color in $colors {
    &_background_#{$color-name} {
      background: $color;

      svg {
        color: contrast-color-to($color, $dark: $color-accent);
      }
    }
  }
}
</style>
